import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4022e5b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dwn-content" }
const _hoisted_2 = { class: "download-content centered" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "h2" }, " Shopkeeper will provide the best and most reliable builds ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "h4" }, " Shopkeeper provides dynamic runes and item recommendations in champion select and during your game ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DownloadBtn = _resolveComponent("DownloadBtn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_DownloadBtn, {
        text: "Download for free",
        isLink: true
      })
    ])
  ]))
}